import { JupiterTheme } from '@jupiterone/jupiter-web-toolkit';
import { Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import React from 'react';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      position: 'absolute',
      padding: theme.spacing(0, 5, 0, 0.75),
      width: '100%',
    },
    prompt: {
      color: theme.palette.coolGrey[400],
      fontFamily: `'Ubuntu Mono', monospace`,
      fontSize: 16,
    },
    helperText: {
      color: theme.palette.coolGrey[300],
      fontSize: 11,
    },
  })
);

const SearchPrompt = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography variant="caption" className={classes.prompt}>
        Enter a search query
      </Typography>
      <Typography variant="caption" className={classes.helperText}>
        SHIFT + RETURN to add line
      </Typography>
    </div>
  );
};

export default SearchPrompt;
